export default "__VITE_ASSET__lyKAYlC$__"